import {cn} from '@containers/html-utils'

/**
 * Add more sizes if you need
 */
export type RingSize = 0 | 1 | 2

/**
 * Add more colors if you need
 */
export type RingColor =
  | 'grey-l100'
  | 'grey-l80'
  | 'grey-l60'
  | 'grey-l20'
  | 'error-l20'
  | 'interactive-l100'
  | 'surface'
  | 'background-primary'
  | 'background-disabled'
  | 'background-subtask-open'
  | 'panel-background-default'
  | 'panel-outline-badge'

const getRingSize = (size: RingSize): string => {
  switch (size) {
    case 0:
      return 'ring-0'
    case 1:
      return 'ring-1'
    case 2:
      return 'ring-2'
    default:
      throw Error(`Unsupported ring size: ${size}`)
  }
}

const getRingColor = (color: RingColor): string => {
  switch (color) {
    case 'grey-l100':
      return 'ring-grey-l100'
    case 'grey-l80':
      return 'ring-grey-l80'
    case 'grey-l60':
      return 'ring-grey-l60'
    case 'grey-l20':
      return 'ring-grey-l20'
    case 'error-l20':
      return 'ring-error-l20'
    case 'interactive-l100':
      return 'ring-interactive-l100'
    case 'surface':
      return 'ring-surface'
    case 'background-primary':
      return 'ring-background-primary'
    case 'background-disabled':
      return 'ring-background-disabled'
    case 'background-subtask-open':
      return 'ring-background-subtask-open'
    case 'panel-background-default':
      return 'ring-panel-background-default'
    case 'panel-outline-badge':
      return 'ring-panel-outline-badge'
    default:
      throw Error(`Unsupported ring color: ${color}`)
  }
}

export const getRing = (size: RingSize, color: RingColor): string =>
  cn('ring', getRingColor(color), getRingSize(size))
